import { ActionableTableColumn } from '../../../Table/ActionableTable'
import { TFunction } from 'react-i18next'

export const getLcdLicensingPaymentHistoryColumns = (
  t: TFunction
): ActionableTableColumn[] => [
  {
    fieldName: 'date',
    columnHeaderName: t('LcdLicensingPaymentHistory.Header.Date', 'Date'),
  },
  {
    fieldName: 'desc',
    columnHeaderName: t(
      'LcdLicensingPaymentHistory.Header.Description',
      'Description'
    ),
  },
  {
    fieldName: 'communityName',
    columnHeaderName: t(
      'LcdLicensingPaymentHistory.Header.CommunityName',
      'Community Name'
    ),
  },
  {
    fieldName: 'communityId',
    columnHeaderName: t(
      'LcdLicensingPaymentHistory.Header.CommunityId',
      'Community Id'
    ),
  },
  {
    fieldName: 'program',
    columnHeaderName: t('LcdLicensingPaymentHistory.Header.Program', 'Program'),
  },
  {
    fieldName: 'paymentMethodKey',
    columnHeaderName: t(
      'LcdLicensingPaymentHistory.Header.PaymentMethod',
      'Payment Method'
    ),
  },
  {
    fieldName: 'acumaticaOrderNumber',
    columnHeaderName: t(
      'LcdLicensingPaymentHistory.Header.AcumaticaOrderNumber',
      'Acumatica Order #'
    ),
  },
  {
    fieldName: 'paymentAmount',
    columnHeaderName: t('LcdLicensingPaymentHistory.Header.Amount', 'Amount'),
  },
  {
    fieldName: 'paymentStatusKey',
    columnHeaderName: t('LcdLicensingPaymentHistory.Header.Status', 'Status'),
  },
]
